import { render, staticRenderFns } from "./ReservationRow.vue?vue&type=template&id=edd41f10&"
import script from "./ReservationRow.vue?vue&type=script&lang=js&"
export * from "./ReservationRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports